<template>
  <v-container fluid style="height: 100vh; max-width: 600px">
    <v-layout column fill-height>
      <v-row class="flex-grow-0">
        <v-toolbar dense elevation="0">
          <v-icon class="pr-1" dense>widgets</v-icon>
          <v-btn rounded text style="font-size: 110%; padding: 0 5px" @click="selectVehicle">{{ vehicle.numericPlate
            }}
          </v-btn>
          <v-spacer></v-spacer>

          <!-- výběr měsíce -->
          <v-menu
            ref="monthMenu"
            v-model="monthMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            nudge-left="100"
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                style="font-weight: bold"
                color="transparent"
                v-bind="attrs"
                v-on="on"
              >{{ formatMonth(month) }}
              </v-chip>
            </template>
            <v-date-picker
              v-model="month"
              @input="monthMenu = false"
              type="month"
              :max="getCurrenDateInMS()"
              no-title
              scrollable
              :locale="getIsoLocale()"
            >
            </v-date-picker>
          </v-menu>

          <!-- export do PDF
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="toReportLogbook" small class="pr-2" v-bind="attrs" v-on="on">
                <v-icon>mdi-file-chart-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.logbook.tooltip.report_logbook") }}</span>
          </v-tooltip>
          -->

          <v-divider vertical class="my-2" inset />

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionVehicle" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-crosshairs-gps</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.vehicle") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionHistory" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.history") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionLogbook" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-text-box-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.logbook") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionRefueling" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>local_gas_station</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.refueling") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionEvents" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>event_available</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.events") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionService" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>build</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.service") }}</span>
          </v-tooltip>

          <v-divider vertical class="my-2" inset />

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="closeContracts" v-bind="attrs" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.close") }}</span>
          </v-tooltip>

        </v-toolbar>
      </v-row>
      <v-row class="overflow-hidden" style="max-height: 100%">
        <v-data-table style="max-height: 100vh; width: 600px"
                      :items="contracts"
                      item-key="name"
                      class="elevation-0 row-height-event map-table"
                      hide-default-header
                      hide-default-footer
                      fixed-header
                      :items-per-page="-1"
                      height="95vh"
        >
          <template v-slot:header="">
            <thead>
            <tr>
              <th>
                {{ $t("map.panel.contracts.column.name") }}<br />
                {{ $t("map.panel.contracts.column.subject") }}
              </th>
              <th>
                {{ $t("map.panel.contracts.column.from") }}<br />
                {{ $t("map.panel.contracts.column.to") }}
              </th>
              <th>
                {{ $t("map.panel.contracts.column.distance") }}<br />
                {{ $t("map.panel.contracts.column.duration") }}
              </th>
              <th style="text-align: end">
                {{ $t("map.panel.contracts.column.amount") }}<br />
                {{ $t("map.panel.contracts.column.amount_km") }}
              </th>
            </tr>
            </thead>
          </template>
          <template v-slot:item="props">
            <tr v-on:click="rowClick(props.item)"
                v-on:contextmenu="rowMenuClick($event, props.item)"
                v-bind:class="{'yellow lighten-4': $store.state.contracts.contract !== null && props.item.contractId === $store.state.contracts.contract.contractId}">
              <td style="white-space: nowrap">
                {{ props.item.name }}<br />
                {{ (props.item.subject !== null) ? props.item.subject.name : "-" }}
              </td>
              <td style="white-space: nowrap">
                {{ formatTimestamp(props.item.fromTimestamp) }}<br />
                {{ formatTimestamp(props.item.toTimestamp) }}
              </td>
              <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 310px">
                {{ formatDistance(props.item.plannedDistance) }} / {{ formatDistance(props.item.actualDistance) }}<br />
                {{ formatDuration(props.item.plannedDuration) }} / {{ formatDuration(props.item.actualDuration) }}
              </td>
              <td style="white-space: nowrap; text-align: end">
                {{ formatAmount(props.item.amount, props.item.currencyCode) }}<br />
                {{ formatAmount(props.item.amountPerKm, props.item.currencyCode) }}
              </td>
            </tr>
            <tr class="yellow lighten-5"
                v-if="$store.state.contracts.contract !== null && props.item.contractId === $store.state.contracts.contract.contractId">
              <td colspan="4">
                <div v-if="$store.state.contracts.contract.rides.length > 0">
                  <table class="cride" style="width: 100%">
                    <tr v-for="ride in $store.state.contracts.contract.rides" v-bind:key="ride.fromTimestamp">
                      <td>
                        <country-flag class="small-flag-move" v-if="getLocationPlaceFlag(ride.locationFrom)"
                                      :country="getLocationPlaceFlag(ride.locationFrom)" size="small" />
                        {{ formatPlace(ride.locationFrom) }}
                        <br />
                        <country-flag class="small-flag-move" v-if="getLocationPlaceFlag(ride.locationTo)"
                                      :country="getLocationPlaceFlag(ride.locationTo)" size="small" />
                        {{ formatPlace(ride.locationTo) }}
                      </td>
                      <td>
                        {{ formatTime(ride.fromTimestamp) }}
                        <br />
                        {{ formatTime(ride.toTimestamp) }}
                      </td>
                      <td>
                        {{ formatDistance(ride.distance) }}
                        <br />
                        {{ formatDuration(rideDuration(ride)) }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-else style="text-align: center; color: gray">{{ $t("map.panel.contracts.noride") }}</div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-menu
          v-model="contextMenu"
          :position-x="contextMenuX"
          :position-y="contextMenuY"
          absolute
          offset-y
        >
          <v-list>
            <v-list-item v-for="(item, index) in getRideContextMenuItems(contextContract)"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { DateTime, Duration } from "luxon";
import utils from "@/utils";
import i18n from "@/plugins/i18n";

export default {
  name: "SideContracts",

  props: {
    vehicleSidebarClick: {}
  },

  data() {
    return {
      monthMenu: false,
      month: null,

      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextContract: null
    };
  },

  methods: {
    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextContract = item;
      this.contextMenu = true;

      event.preventDefault();
    },

    getRideContextMenuItems(event) {
      let menu = [];

      if (event !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.contracts.contract_menu.select") });
        menu.push({ name: "update", title: this.$t("map.panel.contracts.contract_menu.update") });
      }

      return menu;
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "select":
          this.rowClick(this.contextContract);
          break;
        case "update":
          this.$router.push({ name: "data/contract", params: { id: this.contextContract.contractId } });
          break;
      }
    },

    selectVehicle() {
      this.$store.dispatch("dialogs/showDialog", {
        dialog: "vehicleSelection", options: true
      });
    },

    getEventContextMenuItems(ride) {
      let menu = [];

      if (ride !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.logbook.ride_menu.select") });
        if (ride.rideState !== "unfinished" && this.accessRole("admin"))
          menu.push({ name: "update", title: this.$t("map.panel.logbook.ride_menu.update") });
      }

      return menu;
    },

    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").plus({ "days": 1 }).toISO();
    },

    formatMonth(date) {
      if (date !== null)
        return DateTime.fromFormat(date, "yyyy-M").toLocaleString({ month: "long", year: "numeric" });
      else
        return "";
    },

    rowClick(e) {
      this.$store.dispatch("contracts/fetch", {
        periodFrom: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        periodTo: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'"),
        timestamp: e.timestamp,
        contractId: e.contractId
      });

      this.$emit("clicked", e);
    },

    closeContracts() {
      this.$store.dispatch("contracts/clear");
      this.$router.routeToMap();
    },

    actionHistory() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/history",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    actionLogbook() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/logbook",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionRefueling() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/refueling",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionEvents() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/events",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionService() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/service",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    actionVehicle() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/vehicle",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    toReportLogbook() {
      this.$router.push({
        name: "report/logbook", query:
          {
            vehicleId: this.event.vehicleId,
            period: "month-one|" + DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM")
          }
      });
    },

    formatTimestamp(ts) {
      return DateTime.fromISO(ts).toLocaleString(DateTime.DATETIME_SHORT);
    },

    formatDistance(distance) {
      if (distance !== null)
        return utils.formatDistance(distance);
      else
        return "-";
    },

    formatDuration(duration) {
      if (duration !== null)
        return Duration.fromObject({ seconds: duration }).toFormat("h'h' m'm'");
      else
        return "-";
    },

    formatAmount(amount, currencyCode) {
      if (amount !== null)
        return utils.formatAmount(amount, currencyCode);
      else
        return "-";
    },

    formatTime(ts) {
      return DateTime.fromISO(ts).toFormat("HH:mm");
    },

    rideDuration(ride) {
      return DateTime.fromISO(ride.toTimestamp).diff(DateTime.fromISO(ride.fromTimestamp), "seconds").get("seconds");
    },

    getLocationPlaceFlag(location) {
      if (location !== null && location !== undefined && location.place !== null)
        return location.place.countryCode;
      else
        return "";
    },

    formatPlace(location) {
      if (location !== null)
        return utils.formatLocation(location.place);
      else
        return null;
    },

    refreshContracts() {
      return this.$store.dispatch("contracts/fetch", {
        vehicle: this.vehicle.vehicle,
        periodFrom: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        periodTo: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'"),
        contractId: (this.$store.state.contracts.contract != null)
          ? this.$store.state.contracts.contract.contractId
          : null
      });
    },

    updateUrl() {
      this.$router.replace({
        name: "map/contracts",
        params: {
          id: this.$store.state.contracts.vehicle.vehicleId
        },
        query: {
          ...this.$route.query,
          month: this.month,
          contract: (this.$store.state.contracts.contract != null)
            ? this.$store.state.contracts.contract.contractId
            : undefined
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    month: function() {
      if (!DateTime.fromISO(this.$store.state.contracts.periodFrom).equals(DateTime.fromFormat(this.month, "yyyy-M").startOf("month")))
        this.refreshContracts().then(() => this.updateUrl());
    },

    "$store.state.contracts.contract": function() {
      this.updateUrl();
    },

    "$store.state.contracts.contracts": function() {
      this.updateUrl();
    }
  },

  computed: {
    vehicle() {
      return this.$store.state.contracts.vehicle;
    },

    contracts() {
      return this.$store.state.contracts.contracts;
    }
  },

  mounted() {
    this.month = utils.notNullValueOtherNull(this.$route.query["month"], DateTime.now().toFormat("yyyy-M"));
  }
};
</script>

<style lang="sass" scoped>
.list-item-content
  padding: 4px 0 !important

.icon
  padding: 0 5px 0 0 !important
  color: steelblue !important

.list-item-subtitle
  padding: 1px 0 !important
  font-size-adjust: 0.48

.selected
  background: #d3e6e9

.list-item-content-edit
  padding: 4px 0 10px 0 !important

.v-data-table.row-height-event td
  height: 30px !important

table .cride
  border-collapse: collapse

table .cride td
  border: 1px solid lightgray

table .cride tr:first-child td
  border-top: 0

table .cride tr:last-child td
  border-bottom: 0

table .cride tr td
  border-right: 0
  border-left: 0

</style>